import {
  Box,
  CircularProgress,
  makeStyles,
  Typography
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(
  {
    switchAccountLabels: {
      alignSelf: "center",
      color: "#ACCAFF",
      textAlign: "center"
    },
    switchAccountLoader: {
      backgroundColor: "rgba(0,0,0, 0.5)",
      display: "flex",
      height: "100%",
      justifyContent: "center",
      left: 0,
      position: "absolute",
      top: 0,
      width: "100%",
      zIndex: 999999
    },
    switchAccountLoaderText: {
      color: "#fff",
      fontSize: 34,
      fontWeight: 500
    }
  },
  {
    name: "SwitchAccountLoader"
  }
);

const SwitchAccountLoader: React.FC = () => {
  const classes = useStyles({});

  return (
    <div className={classes.switchAccountLoader} id="switchAccountLoader">
      <Box className={classes.switchAccountLabels}>
        <CircularProgress color="inherit" size={89} />
        <Typography component="div" className={classes.switchAccountLoaderText}>
          Switching Account ...
        </Typography>
      </Box>
    </div>
  );
};

SwitchAccountLoader.displayName = "SwitchAccountLoader";
export default SwitchAccountLoader;
